export default __webpack_public_path__ + "static/media/KOD0013-min.1ea39c9a.webp";